<template>
  <div class="s-areatype">
    <div class="rows-types">
        <div class="types">
          <van-tabs v-model="active" @click="clicktab">
            <van-tab title-class="item" v-for="(item,index) in list" :key="index" :title="item.name">
            </van-tab>
          </van-tabs>
        </div>
        <div class="rows-icon">
            <span class="item-icon iconfont  icon-icon-leixing" @click="()=>foldShow=!foldShow"></span>
        </div>
    </div>
    <div class="col-types" v-if="foldShow">
      <div class="types">
          <div class="item" v-for="(item,index) in list" :key="index" @click="selectType(item,index)">{{item.name}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState,mapActions } from 'vuex';
export default {
  name: '',
  props: {
    // colorIndex: Number | String,
  },
  data() {
    return {
      foldShow: false,
      active: 1,
      list:[],
    }
  },
  computed:{
    ...mapState(['allType'])
  },
 
  mounted(){
    this.$nextTick(()=>{
      let subtype = this.$utils.getParams("subtype")
      this.init(subtype)
      
    })
  },
  methods:{
    ...mapActions(['getAllType']),
      init(subtype){
        this.getAllType().then(list=>{
          list.unshift({
            name:'全部',
            id:-1
          })
          this.list = list
          let item = list.find(t=>{ return t.id==subtype})
          let index = list.findIndex(t =>{ return t.id == subtype})
          if(item){
            this.$emit('change',{item,index})
          }
        })
      },
      clicktab(name,title){
          this.active = name;
          let index = name;
          let item = this.list.find((res)=>{return title==res.name;})
          this.$emit("change", { item, index });
      },
      selectType(e,key){
          this.active = key;
          this.foldShow = false;
          let index = key;
          let item = this.list.find((res)=>{return e.name==res.name;})
          this.$emit("change", { item, index });
      }

  },
}
</script>
<style scoped lang="scss">
.s-areatype{
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 40rem;
  // height: 30rem;
  background: rgba($color: #fff, $alpha: 0.9);
  z-index: 20;
  display: flex;
  .rows-types{
    display: flex;
    align-items: center;
    box-sizing: border-box;
    width: 100vw;
    height: 40rem;
    overflow: hidden;
    justify-content: space-between;
  }
  .types{
    width: calc(100vw - 50rem);
    height: 28rem;
    :deep(.van-tabs--line .van-tabs__wrap){
      height: 28rem!important;
    }
    :deep(.van-tabs ){
      height: 28rem;
      .van-tab{
        font-size: 12rem;
      }
      
      .van-tabs__nav--line{
        height: 28rem;
      }
    }
    :deep(.van-tabs__nav){
      background: none;
      padding-top: 7rem;
      .van-tab{
        border-radius: 15rem;
        height: 28rem;
        line-height: 18rem;
      }
      .van-tab--active{
        background: var(--mainColor);
        border: none;
        color: #fff;
      }
      .van-tabs__line{
        display: none;
      }
    }
    
  }
  .rows-icon{
    width: 50rem;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #444;
    position: relative;
    &::before{
      content: "";
      width: 1px;
      height: 15rem;
      background-color: #999;
      position: absolute;
      left: 0;
      top: 50%;
      transform: translate(0,-50%);
    }
    .iconfont{
      font-size: 18rem;
    }
  }

  .col-types{
    position: absolute;
    top: 40rem;
    left: 0;
    width: 100%;
    padding: 0 10rem 0;
    background: inherit;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    .types{
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      margin-top: 10rem;
      margin-bottom: 7rem;
      .item{
        color: var(--mainColor);
        border-radius: 15rem;
        border: .5rem solid var(--mainColor);
        padding: 6rem 10rem;
        margin: 0 10rem 13rem 0;
      }
    }
  }
}
</style>
